import React from 'react';
import styled from 'styled-components';

export default function RadioButton({selected, onPress, label, className}) {
    return (
        <Container onClick={onPress} className={className}>
            <Text>{label}</Text>
            <Circle selected={selected}>
                <InnerCircle selected={selected} />
            </Circle>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    height: 46px;
    background-color: white;
    align-items: center;
    border-radius: 10px;
    padding: 0 15px;
    margin-bottom: 10px;
    cursor: pointer;
`;

const Text = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: black;
    flex: 1;
`;

const Circle = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 13px;
    align-items: center;
    justify-content: center;
    display: flex;

    background: ${({selected}) =>
        selected
            ? 'linear-gradient(90deg, #f55a86 0%, #ec098c 100%)'
            : '#E0E0E0'};
`;

const InnerCircle = styled.div`
    width: ${({selected}) => (selected ? '14px' : '20px')};
    height: ${({selected}) => (selected ? '14px' : '20px')};
    background-color: white;
    border-radius: 10px;
`;
